import { useContext } from "react";

import MenuGroupContext from "contexts/MenuGroupContext";

const useMenuGroup = () => useContext(MenuGroupContext);

export default useMenuGroup;
